
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              久下暁雅
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              俳優としての演技経験を楽曲の表現に昇華させる、類い稀なシンガーソングライター。心揺さぶるパフォーマンスを是非、ライブや音源でお楽しみください。<br />
              カフェライブツアー、オンラインファンクラブコミュニティ立ち上げ企画が進行中。
            </p>
            <div className="flex space-x-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
              <a href="https://spotify.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-spotify-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="/profile" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Profile</a></li>
              <li><a href="/discography" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Discography</a></li>
              <li><a href="/live" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Live</a></li>
              <li><a href="/blog" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Blog</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
            <ul className="space-y-2 text-gray-300">
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                info@kushita-akimasa.com
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                03-1234-5678
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  お問い合わせフォーム
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 久下暁雅 &amp; Rising Sun All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}
